import { theme as baseTheme } from '@hotelescalle1/heyrev-core-kit'
import { createTheme } from '@mui/material/styles'

/**
 * auth-hc1-mgr's MUI theme — extends heyrev-core-kit's default theme
 * (shared palette/typography/component overrides). Add app-specific
 * overrides here via the second `createTheme` argument, e.g.
 * `createTheme(baseTheme, { palette: { myColor: { main: '#...' } } })`.
 */
const theme = createTheme(baseTheme)

export default theme
